import { SheetTop } from '../SheetTop'
import { SelectedTicket } from './SelectedTicket'
import './yourSelection.scss'

export default function YourSelection({
  toggleView,
  canGoBack,
  goBack,
  selectedFromMap,
  eventTicketLimit,
  totalCount = 0,
  processingFee = 0,
  showProcessingFee = false,
  isSeasonPackage = false,
  showBaseTicketPrice = false,
}) {
  const processingFeePerTicket =
    showProcessingFee && totalCount > 0 ? processingFee / totalCount : 0

  return (
    <div className="vjy-yb">
      <SheetTop canGoBack={canGoBack} goBack={goBack} />
      <div className="vjy-sc">
        {eventTicketLimit && (
          <span className="vjy-etl">
            Event ticket limit: {eventTicketLimit}
          </span>
        )}
        {selectedFromMap &&
          selectedFromMap.map((ticketGroup, i) => {
            if (ticketGroup.GA === true) {
              return Array(ticketGroup.quantity)
                .fill()
                .map((_, j) => (
                  <SelectedTicket
                    key={`ga-${i}-${j}`}
                    ticketGroup={ticketGroup}
                    toggleView={toggleView}
                    processingFeePerTicket={processingFeePerTicket}
                    showProcessingFee={showProcessingFee}
                    isSeasonPackage={isSeasonPackage}
                    showBaseTicketPrice={showBaseTicketPrice}
                  />
                ))
            } else {
              return (
                <SelectedTicket
                  key={`seat-${i}`}
                  ticketGroup={ticketGroup}
                  toggleView={toggleView}
                  processingFeePerTicket={processingFeePerTicket}
                  showProcessingFee={showProcessingFee}
                  isSeasonPackage={isSeasonPackage}
                  showBaseTicketPrice={showBaseTicketPrice}
                />
              )
            }
          })}
      </div>
    </div>
  )
}
